




import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import SimpleText from "front-component/components/SimpleText.vue";

interface Catalog {
  armisValidation: boolean;
}

@Component({ components: { SimpleText } })
export default class ArmisValidation extends Vue {
  @Prop() public catalog !: Catalog;

  public static getNeededFields(): string[] {
    return [
      "catalog.armisValidation",
    ];
  }
}
